import { PropType } from 'vue';
import { mapState } from 'vuex';
import { Options, Vue } from 'vue-class-component';
import {
  GateGuestDTO,
  EntrancePlantDetailDTO,
} from '@/../client-generator/generated-clients/plants';
import GuestItem from '../../../EntrancePlantGuests/GuestItem/GuestItem.vue';

@Options({
  name: 'GuestSelector',
  props: {
    fromGuestTab: {
      type: Object as PropType<GateGuestDTO>,
      required: false,
      default: null,
    },
  },
  computed: {
    ...mapState(['currentEntrancePlant']),
  },
  components: {
    GuestItem,
  },
  emits: ['guest-selected'],
})
export default class GuestSelector extends Vue {
  currentEntrancePlant!: EntrancePlantDetailDTO;
  fromGuestTab!: GateGuestDTO;
  selectedGuest: GateGuestDTO | null = null;

  mounted() {}

  get guests() {
    const today = Date.parse(new Date().toDateString());

    const validGuestForBadge = this.currentEntrancePlant.gateGuests?.filter(
      (guest) => {
        const guestNotExpired =
          guest.durationUntil === undefined ||
          (guest.durationUntil && guest.durationUntil.valueOf() >= today);
        const guestNotHasBadge = guest.badgeCode === '' || !guest.badgeCode;
        if (guest.isRecurrent && guestNotExpired && guestNotHasBadge) {
          return true;
        }
      }
    );

    return validGuestForBadge;
  }

  selectGuest(guest: GateGuestDTO) {
    this.$emit('guest-selected', guest);
  }
}
